import React, { useRef, useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { ReactComponent as CloseModalIcon } from '../../../assets/svg/CloseModalIcon.svg';
import { ReactComponent as Save } from '../../../assets/svg/Save.svg';
import Loading from '../../../utils/Loading';
import { createUserSubsciption, getSubscriptionCatalog } from '../../../server/server';

const subscriptionPlanList = [
	{ name: 'trial', icon: <Save />, color: '#CAE5FF' },
	{ name: 'starter', icon: <Save />, color: '#CAE5FF' },
	{ name: 'advanced', icon: <Save />, color: '#91C9FF' },
	{ name: 'family', icon: <Save />, color: '#BF9ED9' },
];

const durationList = [{ name: 'Continue subscription' }, { name: 'Extend for a month' }, { name: 'Extend for a 3 months' }, { name: 'Extend for a year' }, { name: 'Lifetime' }, { name: 'Custom' }];

function ChangeSubscriptionModal({ modalIsOpen, closeModal, user = null, reloadList }: { modalIsOpen: any; closeModal: any; user: any; reloadList?: any }) {
	const [processing, setProcessing] = useState(false);
	const [selectedPlanIndex, setSelectedPlanIndex] = useState(-1);
	const [selectedDurationIndex, setSelectedDurationIndex] = useState(-1);
	const [selectedSubscription, setSelectedSubscription] = useState<any>(null);
	const [subscriptions, setSubscriptions] = useState<any[]>([]);

	useEffect(() => {
		if (modalIsOpen && !!user) loadSubscriptions();
	}, [modalIsOpen, user]);

	const loadSubscriptions = async () => {
		const resp = await getSubscriptionCatalog();
		if (resp.status === 200) {
			setSubscriptions(resp.data);
		}
	};

	const cleanUpFunction = () => {
		setSelectedPlanIndex(-1);
		setSelectedDurationIndex(-1);
	};

	const handlePlan = (item: any, index: number) => {
		setSelectedSubscription(item);
		setSelectedPlanIndex(index);
	};

	const subscribeUser = async () => {
		setProcessing(true);
		const data = {
			userId: user?.id,
			subscriptionId: selectedSubscription?.id,
			duration: selectedSubscription?.duration,
		};
		const resp = await createUserSubsciption(data);
		if (resp.status === 201) {
			reloadList();
			closeModal();
			setProcessing(false);
		} else {
			setProcessing(false);
		}
	};

	return (
		<ReactModal
			isOpen={modalIsOpen}
			onAfterOpen={() => {}}
			onAfterClose={() => cleanUpFunction()}
			onRequestClose={closeModal}
			style={{
				overlay: {
					zIndex: 7,
					background: '#00000045',
				},
				content: {
					padding: 0,
					paddingTop: 30,
					paddingBottom: 30,
					opacity: 1,
					width: 800,
					margin: 'auto',
					backgroundColor: 'transparent',
					maxHeight: '100vh',
					border: '0px',
					boxShadow: 'none',
					overflow: 'auto',
				},
			}}
			className={'no-scroll outline-0'}
		>
			<div className='student-info-modal  '>
				<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<div className='close-modal-icon ' onClick={() => closeModal()}>
						<CloseModalIcon />
					</div>
				</div>

				<div className='bg-white rounded-xl mx-3 flex-1 flex flex-col gap-5 px-[40px] py-[25px]'>
					<div className='flex-1'>
						<p className='text-blueLight font-semibold text-3xl text-left'>Edit user's subscription</p>
					</div>

					<p className='text-blueLight text-[20px] leading-6 font-bold mt-3 '>Subscription plan</p>
					<div className='grid grid-cols-2 justify-center mx-auto gap-3 '>
						{!!subscriptions &&
							subscriptions?.map((item: any, index: number) => (
								<div
									className={`w-[300px] p-[15px] flex flex-col gap-3 items-center justify-center  rounded-[20px]  cursor-pointer border-[2px] ${
										selectedSubscription?.name === item.name ? 'shadow-2xl' : ''
									}`}
									key={index}
									onClick={() => handlePlan(item, index)}
									style={{ backgroundColor: item.color, borderColor: selectedPlanIndex === index ? '#5e639b' : '#5e639b80' }}
								>
									{item.icon}
									<p className='text-blueLight text-[20px] leading-6 font-bold capitalize'>{item.name}</p>
									<p className='text-blueLight text-[20px] leading-6 font-bold capitalize'>{item.duration} dana</p>
								</div>
							))}
					</div>

					<div className='flex flex-row justify-end w-full gap-5 mt-2'>
						{/* <div
							className='flex-1 max-w-[160px] flex flex-row items-center justify-center cursor-pointer rounded-full bg-[#fafaff]  h-[60px] button-transparent-class'
							onClick={closeModal}
						>
							<p className='text-[18px] text-primaryViolet leading-5 font-semibold mr-3 '>Back</p>
						</div> */}
						<button
							className='flex-1 max-w-[160px] flex flex-row items-center justify-center cursor-pointer  rounded-full bg-blueMedium  min-h-[60px] button-save-class transition'
							disabled={processing}
							onClick={() => subscribeUser()}
						>
							{processing ? (
								<Loading primaryColor='#FDDF6D' secondaryColor='#5E639B' size={25} stroke={7} />
							) : (
								<div className='flex flex-row items-center justify-center'>
									<p className='text-[18px]  leading-5 font-semibold mr-3 text-white'>Save</p>
									<Save color='white' />
								</div>
							)}
						</button>
					</div>
				</div>
			</div>
		</ReactModal>
	);
}

export default ChangeSubscriptionModal;
